module.exports = __webpack_public_path__ + "static/media/PuzzleFont.d380c3d0.otf";